import React, {useState} from "react";
import {Link} from "react-router-dom";
import {useAppSelector} from "../../../utils/Hooks";

interface ClientsTableProps {
}

export const ClientsTable: React.FC<ClientsTableProps> = () => {

    const calientsState = useAppSelector(state => state.clients);

    return (
        <table className="data">
            <thead>
            <tr>
                <th>Ettevõte</th>
                <th>Kommentaar</th>
                <th className="right w150"></th>
            </tr>
            </thead>
            <tbody>
            {calientsState.clients.map(row => {
                return (
                    <tr>
                        <td>
                            {row.name}
                        </td>
                        <td>
                            {row.comment}
                        </td>
                        <td className="action">
                            <Link to={`/clients/${row.id}/contacts`}>Kontaktid</Link>
                            <span>|</span>
                            <Link to={`/clients/${row.id}/loadings`}>   Laadimised</Link>
                            <span>|</span>
                            <Link to={`/clients/${row.id}/modify`}>Muuda</Link>
                            <span>|</span>
                            <Link to={`/clients/${row.id}/delete`}>Kustuta</Link>
                        </td>
                    </tr>
                )
            })}
            </tbody>
        </table>
    );

}